import React from 'react';
import { SUBMISSION_STATUS } from './constants';
import LoadingSpinner from '../loadingSpinner';

export const ActionButton = ({ 
  isInternal, 
  status, 
  handleSubmit, 
  loading, 
  isExternalFormSubmitted, 
  errors,
  fileError
}) => {
  let label = 'Submit';
  const numberOfErrors = Object.keys(errors).length;

  if (isInternal) {
      switch (status) {
          case SUBMISSION_STATUS.SUBMITTED:
          case SUBMISSION_STATUS.IN_PROGRESS:
              label = 'Submit For DC Review';
              break;
          case SUBMISSION_STATUS.DC_REVIEW:
              label = 'Submit Review';
              break;
          case SUBMISSION_STATUS.PENDING_DISTRIBUTION:
              label = 'Mark RFI As Complete';
              break;
          default:
              break;
      }
  }

  // no action necessary if the RFI process is complete
  if (status === SUBMISSION_STATUS.COMPLETE) {
      return null;
  }

  return (
      <>
        {numberOfErrors > 0 
            ? 
                <div className={'error-message'} style={{textAlign: 'right', marginBottom: '-25px', marginTop: '25px'}}>
                    *Unable to finalize form. Error{numberOfErrors === 1 ? '' : 's'} in {numberOfErrors} of the fields.
                </div>
            : fileError
                ?
                    <div className={'error-message'} style={{textAlign: 'right', marginBottom: '-25px', marginTop: '25px'}}>
                        *Unable to finalize form. {fileError}
                    </div>
                : null
        }
          <button 
              onClick={loading ? null : handleSubmit}
              className="submit-button" 
              style={{ cursor: isExternalFormSubmitted ? 'default' : 'pointer' }} 
              disabled={loading || isExternalFormSubmitted}>
              {loading ? (
                  <>
                      <LoadingSpinner />
                      <div style={{marginLeft: '20px'}}>Processing request...</div>
                  </>)
                  :
                  <div>{label}</div>
              }
          </button>
          {status === SUBMISSION_STATUS.PENDING_DISTRIBUTION && 
              <div style={{fontSize: '12px'}}>
                  Note: You need to download the PDF and manually send it to the contractor. Clicking this button only changes the status of the RFI to complete and makes it read only.
              </div>
          }
      </>
  );
}